import { ResetCoreqSectionsMetasourceCommand } from '../../commands/reset_coreq_sections_metasource_command';
import { SaveCourseAlertsCommand } from '../../../components/course_alerts/commands/save_course_alerts_command';
import { INotificationDelegate } from '../../../global/helpers/scheduler_notification_delegate';
import { TermCourseServant } from '../../../views/term_courses/servants/term_course_servant';
import { SchedulerActiveTermQuery } from '../../../scheduler_active_term/queries/scheduler_active_term_query/scheduler_active_term_query';
import { RemovePlannedCourseSchedulerCommand } from '../../commands/remove_planned_course_scheduler_command';
import { CourseDetailsFacade } from '../../../views/course_details/facades/course_details_facade';
import { ITermCourse } from '../../../interfaces/scheduler_interfaces';
import { SearchAndCourseFeatureFacade } from '../../facades/search_and_courses_feature_facade';
import { ViewSectionsFacade } from '../../../views/term_courses/facades/view_sections_facade';
import { CommunicatorService } from 'ui-ng-component-communicator';
import * as _4 from 'lodash4';

class SchedulerPlannedCourseMenuController {
  private course: ITermCourse;
  private hasDevreq: boolean;
  private hasMissingReqs: boolean;
  private showRemoveCoursePopup: boolean = false;
  private showRemoveCourseMenuItem: boolean = true;
  private showAlertsMenuItem: boolean = false;

  constructor(
    private ngSearchAndCourseFeatureFacade: SearchAndCourseFeatureFacade,
    private ngSchedulerActiveTermQuery: SchedulerActiveTermQuery,
    private removePlannedCourseSchedulerCommand: RemovePlannedCourseSchedulerCommand,
    private resetCoreqSectionsMetasourceCommand: ResetCoreqSectionsMetasourceCommand,
    private ngCourseDetailsFacade: CourseDetailsFacade,
    private ngTermCourseServant: TermCourseServant,
    private ngSchedulerNotificationDelegate: INotificationDelegate,
    private ngViewSectionsFacade: ViewSectionsFacade,
    private ngComponentCommunicatorService: CommunicatorService,
    private saveCourseAlertsCommand: SaveCourseAlertsCommand
  ) {}

  $onInit() {
    const hasMissingPrereqs = this.ngTermCourseServant.hasPreRequistes(this.course);
    const hasMissingCoreqs = this.ngTermCourseServant.hasCoRequistes(this.course);
    this.hasDevreq = this.ngTermCourseServant.isDevReq(this.course);
    this.hasMissingReqs = hasMissingPrereqs || hasMissingCoreqs;
    this.showAlertsMenuItem = this.hasMissingReqs || this.hasDevreq;
  }

  $onChanges() {
    const isCourseScheduled = this.ngTermCourseServant.isPartiallyScheduled(this.course);

    if (!this.ngSearchAndCourseFeatureFacade.isFeatureEnabled) {
      this.showRemoveCourseMenuItem = false;
      return;
    }

    this.showRemoveCourseMenuItem = !isCourseScheduled;
  }

  showSections() {
    return this.ngViewSectionsFacade.showSections(this.course);
  }

  openCourseDetail() {
    this.ngCourseDetailsFacade.openCourseDetails(this.course.nk);
  }

  openAlertsDrawer() {
    this.saveCourseAlertsCommand({
      course: this.course,
      hasDevReq: this.hasDevreq,
      hasMissingReqs: this.hasMissingReqs
    }).then(() => {
      this.ngComponentCommunicatorService.publish('OPEN_COURSE_ALERTS_MODAL');
    });
  }

  openRemoveCoursePopup() {
    this.showRemoveCoursePopup = true;
  }

  removeCourseDialogClosed() {
    this.showRemoveCoursePopup = false;
  }

  removeCourse() {
    const notifDelegateName = `remove-course-progress-${this.course.id}`;
    this.ngSchedulerNotificationDelegate.info({
      content: `Removing of course (${this.course.cd} ${this.course.title}) started`,
      showIcon: true,
      name: notifDelegateName,
      iconClass: 'eab-icon-sync'
    });
    this.removePlannedCourseSchedulerCommand(this.course.id)
      .then(() => {
        this.resetCoreqSectionsMetasourceCommand(this.course.id);
        this.ngSchedulerNotificationDelegate.dismissAlertByName(notifDelegateName);
        this.ngSchedulerNotificationDelegate.success({
          content: `Successfully removed the course (${this.course.cd} ${this.course.title})`,
          name: `${notifDelegateName}-success`,
          timeout: 10000
        });
      })
      .finally(() => {
        this.ngSchedulerNotificationDelegate.dismissAlertByName(notifDelegateName);
        this.removeCourseDialogClosed();
      });
  }
}

angular.module('capability-ng-scheduler').component('schedulerPlannedCourseMenu', {
  templateUrl:
    'capability-ng-scheduler/src/search_and_add_courses/components/scheduler_planned_course_menu/scheduler_planned_course_menu.html',
  controller: SchedulerPlannedCourseMenuController,
  bindings: {
    course: '<'
  }
});



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/search_and_add_courses/components/scheduler_planned_course_menu/scheduler_planned_course_menu.ts